import { Form } from '@appsumo/dorado-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { BillingDetailsProps } from '~/types/checkout';

export function TaxIdCollection({
  isCountryAus,
  show,
  toggleTaxCollection,
  billingDetails,
}: {
  isCountryAus: boolean;
  show: boolean;
  toggleTaxCollection: () => void;
  billingDetails: BillingDetailsProps;
}) {
  if (!isCountryAus) return <></>;

  if (!show)
    return (
      <div className="mb-6 text-sm">
        <span className="mr-1">Purchasing on behalf of a business?</span>
        <button
          className="text-bolt"
          type="button"
          onClick={() => toggleTaxCollection()}
          data-testid="billing-checkout-tax-toggle"
        >
          Add your tax information
        </button>
      </div>
    );

  return (
    <div>
      <div className="my-6 h-[1px] border-b border-sundog" />
      <div className="mb-4 flex gap-2" data-testid="billing-checkout-tax-form">
        <div className="w-1/2">
          <Form.Input
            name="tax_business_name"
            label="Business name"
            defaultValue={billingDetails?.taxBusinessName || ''}
          />
        </div>
        <div className="w-1/2">
          <Form.Input
            name="tax_id"
            label="Tax ID"
            defaultValue={billingDetails?.taxId || ''}
          />
        </div>
      </div>
      <div className="flex justify-end">
        <button
          className="text-sm text-brick"
          onClick={() => toggleTaxCollection()}
          type="button"
        >
          <FontAwesomeIcon icon={faTrash} className="mr-2" />
          Remove tax information
        </button>
      </div>
    </div>
  );
}
